<template>
  <div>
    <div v-if="isModal" dir="ltr">
      <LinkEntity :payload="applicant"></LinkEntity>
    </div>
    <div v-if="messageOccurence.length > 0">
      <p>Message</p>
      <div class="box">
        <div class="content">
          <ul class="mx-4">
            <li v-for="(occurence, idx) in messageOccurence" :key="idx" v-html="$sanitize(occurence)"></li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="tagsOccurence.length > 0">
      <p>Tags</p>
      <div class="box">
        <div class="content">
          <ul class="mx-4">
            <li v-for="(occurence, idx) in tagsOccurence" :key="idx" v-html="$sanitize(occurence)"></li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="textOccurence.length > 0">
      <p>Texts</p>
      <div class="box">
        <div v-for="(text, idx) in textOccurence" :key="idx" class="content">
          <div v-if="text.occurances.length > 0">
            <h6 class="has-text-weight-bold">{{ text.designator }}</h6>
            <ul class="mx-4">
              <li v-for="(occurence, idx) in text.occurances" :key="idx" v-html="$sanitize(occurence)"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LinkEntity from '@/components/LinkEntity'

export default {
  name: 'text-search-result',
  components: {
    LinkEntity
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    },
    applicant: {
      type: Object
    },
    searchKeyword: {
      type: String,
      required: true
    },
    tags: {
      type: String,
      default: ' '
    },
    message: {
      type: String,
      default: ' '
    },
    text: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    messageOccurence () {
      return this.occurence(this.message)
    },
    tagsOccurence () {
      return this.occurence(this.tags)
    },
    textOccurence () {
      return this.text.map(text => ({
        occurances: this.occurence(text.content),
        designator: text.designator
      }))
    }
  },
  methods: {
    occurence (string) {
      if (!string) return []
      const charsCount = 100
      const str = string.toLowerCase()
      const startingIndices = []
      this.searchKeyword.split(' + ').forEach(search => {
        const word = new RegExp(search, 'gi')
        let indexOccurence = str.indexOf(search.toLowerCase(), 0)
        while (indexOccurence >= 0) {
          const left = indexOccurence - charsCount < 0 ? 0 : indexOccurence - charsCount
          const right =
            indexOccurence + search.length + charsCount > str.length
              ? str.length
              : indexOccurence + search.length + charsCount
          const leftDots = left == 0 ? '' : '...'
          const rightDots = right == str.length ? '' : '...'
          startingIndices.push(`${leftDots}${str.substring(left, right)}${rightDots}`.replace(word, `<span class="is-warning">$&</span>`))
          indexOccurence = str.indexOf(search.toLowerCase(), indexOccurence + 1)
        }
      })
      return startingIndices
    }
  }
}
</script>
